module.exports = __webpack_public_path__ + "img/logo_white.adee67a3.svg";